import React, { Component } from 'react'
import axios from 'axios'

import { withCookies } from 'react-cookie'
import withData from 'utils/withData'
import LrsClient from 'utils/lrs_client'
import UncaughtException from 'components/UncaughtException'

import { Layout, LoadingComponent, ErrorComponent, PrivateRoute } from 'components'
import { Home, Trails, TrailDetails, Article } from 'views'

import './App.css'

LrsClient.enableCrossWindowTracking()

class App extends Component {
  state = {
    isAuthenticated: false,
    isLoading: false,
    allowedAndroid: true,
  }

  componentWillMount() {
    this.setState({ isLoading: true })

    if (parseInt(this.getAndroidVersion()) <= 5) {
      this.setState({ allowedAndroid: false })
    }

    const { cookies } = this.props

    axios({
      method: 'get',
      url: `${process.env.REACT_APP_AUTH_URL}/auth`,
      crossdomain: true,
    })
      .then(response => {
        const authCookies = response.data.data

        // Override cookie values.
        authCookies.domain = process.env.REACT_APP_DRUPAL_COOKIE_DOMAIN
        authCookies.expires = new Date(authCookies.expires)

        // Set cookies.
        cookies.set(authCookies.name, authCookies.value, authCookies)
        //// UNCOMMENT BELOW LINE TO USE http://moby.local.plurall.net
        //// REMEMBER YOURSELF TO SET CORRECT COOKIE NAME AND VALUE FROM http://moby.local.plurall.net
        //cookies.set('SESSed645a156c15f38f6258d6502fa29b36', '2aGlv0ImggCzh82PK4v33knJlwRjiHE4WCTXAWQbY0A', authCookies)

        this.setState({ isLoading: false, isAuthenticated: true })
      })
      .catch(error => {
        this.setState({ isLoading: false })
        console.log(error)
      })
  }

  componentDidMount() {
    const { REACT_APP_SENTRY_DSN, REACT_APP_NODE_ENV } = process.env

    if (REACT_APP_SENTRY_DSN) {
      window.Raven.config(REACT_APP_SENTRY_DSN, {
        environment: REACT_APP_NODE_ENV,
      }).install()
    }

    window.PLURALL_TRACKER.pageView()
  }

  getAndroidVersion = () => {
    const ua = navigator.userAgent.toLowerCase()
    const match = ua.match(/android\s([0-9.]*)/i)
    return match ? match[1] : undefined
  }

  render() {
    const { isAuthenticated, isLoading, allowedAndroid } = this.state

    return (
      <UncaughtException>
        {!allowedAndroid ? (
          <Layout>
            <ErrorComponent message='Olá! Para acessar este conteúdo, é necessário que atualize o sistema Android para a versão 6 ou superior. Por enquanto, você pode acessar normalmente este conteúdo pelo navegador do seu computador.' />
          </Layout>
        ) : (
          <>
            {isLoading && <LoadingComponent />}

            {!isLoading && isAuthenticated && (
              <Layout>
                <PrivateRoute exact path='/' component={Home} />
                <PrivateRoute exact path='/trails' component={Trails} />
                <PrivateRoute path='/trails/:slug' component={TrailDetails} />
                <PrivateRoute path='/node/:slug/:latest?' component={Article} />
              </Layout>
            )}

            {!isLoading && !isAuthenticated && (
              <Layout>
                <ErrorComponent message='Authentication failed.' />
              </Layout>
            )}
          </>
        )}
      </UncaughtException>
    )
  }
}

export default withCookies(withData(App))
